import Vue from 'vue';
import Router from 'vue-router';
import MapAppVue from '@/components/maps/MapApp';
// import PlotAppVue from '@/components/charts/PlotApp';
import VizAppVue from '@/components/visualization/VizApp';
import PlotDetailsVue from '@/components/visualization/plot-edit/PlotDetails';
import RealTimeVue from '@/components/realtime/RealtimeApp';
import BioAcousticVue from '@/components/bio-acoustic-demo';
import SeafloorDemoVue from '@/components/seafloor-photomosaic';
import AppInfoVue from '@/components/AppInfo';
import LandingPageVue from '@/components/dashboard/LandingPage';
import Page404Vue from '@/components/Page404';
import DAPageVue from '@/components/DAPage/DAPageApp';
import DataInfoVue from '@/components/instrumentPage/InstrumentPageApp';

Vue.use(Router);

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      name: '404',
      component: Page404Vue,
    },
    {
      path: '/',
      name: 'Home',
      component: LandingPageVue,
    },
    {
      path: '/map',
      name: 'MapApplication',
      component: MapAppVue,
    },
    // {
    //   path: '/visualize',
    //   name: 'VisualizationPortal',
    //   component: PlotAppVue,
    // },
    {
      path: '/plot',
      name: 'VisualizationPortal2',
      component: VizAppVue,
    },
    {
      path: '/plot/:id',
      name: 'PlotDetails',
      component: PlotDetailsVue,
      props: (route) => ({
        area: route.query.area,
        infrastructure: route.query.infrastructure,
        instrument: route.query.instrument,
        d: route.query.d, // current dataset id
        selected: route.query.selected, // selected instrument in current id
        // Form options for specified dataset
        x: route.query.x,
        y: route.query.y,
        color_active: route.query.color_active,
        color: route.query.color,
        color_min: route.query.color_min,
        color_max: route.query.color_max,
        color_theme: route.query.color_theme,

      }),
    },
    { path: '/realtime', redirect: '/realtime/all' },
    {
      path: '/realtime/:inst_group',
      name: 'RealTimeApp',
      component: RealTimeVue,
    },
    {
      path: '/bio-acoustic-demo',
      name: 'BioAcousticDemo',
      component: BioAcousticVue,
    },
    {
      path: '/seafloor-photomosaic-demo',
      name: 'SeafloorDemo',
      component: SeafloorDemoVue,
    },
    {
      path: '/app-info',
      name: 'AppInfo',
      component: AppInfoVue,
    },
    {
      path: '/data-availability',
      name: 'DataAvailabilityPortal',
      component: DAPageVue,
    },
    {
      path: '/data-info',
      name: 'DataInformationPage',
      component: DataInfoVue,
    },
  ],
});
